import { Box, Grid } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import moment from 'moment';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';

const storageId = sessionStorage.getItem('idUsuario');
export default function TabAprobacion({
    idCapa,
    isNew,
    allowedWrite,
    onChange,
    capaFormData
}) {
    const calculateCapaVencida = (fechaCierre, fechaAccion, prorrogas) => {
        const ultimaProrroga = prorrogas?.length > 0
            ? moment(prorrogas[prorrogas.length - 1].fechaProrroga)
            : moment(fechaAccion);

        const fechaCierreCapa = moment(fechaCierre);
        const diferencia = fechaCierreCapa.diff(ultimaProrroga, 'days') - 7;
        return diferencia > 1;
    };

    const handleInputChange = useCallback((fieldName, value) => {
        onChange({
            [fieldName]: value
        });
    }, [onChange]);

    const updatedInputs = useMemo(() => {
        return (structuredClone(inputs).map(input => {
            switch (input.name) {
                case 'capaVencida':
                    handleInputChange('capaVencida', calculateCapaVencida(
                        capaFormData?.stage3?.fechaCierre,
                        capaFormData?.stage1?.fechaAccion,
                        capaFormData?.stage2?.prorrogaCapa
                    ));
                    break;
                default:
                    break;
            }
            if (!allowedWrite) {
                input.disabled = true;
            }
            return input;
        }))
    }, [
        allowedWrite,
        capaFormData?.stage3?.fechaCierre
    ]);
    
    return (
        <div>
            <Grid container spacing={2}>
                {updatedInputs
                    .map((input, index) => (
 <Grid key={`input-${input.name}-index-${index}`} size={{ xs: input.col }}>
                            <RenderInputByTypeMobile
                                key={`input-${input.name}-index-${index}`}
                                input={input}
                                handleChange={handleInputChange}
                                value={capaFormData?.stage3[input.name]}
                            />
                        </Grid>))}
 <Grid size={{ xs: 6 }} />
            </Grid>
        </div>
    )
}

const inputs = [

    {
        name: 'fechaCierre',
        displayName: 'Fecha de cierre capa',
        type: 'date',
        required: true,
        col: 2.5
    },
    {
        name: 'agregarProrroga',
        type: 'item',
        hidden: true,
        disabled: false,
        col: 10
    },
    //row
    {
        name: 'observacionFinal',
        displayName: 'Observación final',
        type: 'long_string',
        disabled: false,
        col: 12
    },
    //row
    {
        name: 'capaVencida',
        disabled: true,
        displayName: 'Capa vencida',
        type: 'custom_switch',
        col: 3
    },
];